import React from 'react';
// import { FaFacebook, FaInstagram, FaTwitter, FaLinkedin, FaYoutube } from 'react-icons/fa';
import logoo from './images/logoo.png';
// import Link from 'react-router-dom';

const Contentdown = () => {
  return (
    <footer className="bg-dark text-light py-10 px-5">
      <div className="max-w-screen-xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8">
        {/* Column 1 */}
        <div>
          <a href="/" className="inline-block p-3 mt-2 bg-white rounded navbar-brand">
            <img src={logoo} width={50} height={50} alt="Logo" />
          </a>
          <p className="text-sm mt-4 leading-relaxed">
            We help businesses thrive online by providing top-notch eCommerce solutions with innovative tools and expert support. Join us to transform your eCommerce journey and achieve success in the digital marketplace!
          </p>
          <p className="mt-6 font-semibold text-base">Stay In Touch</p>
          <p className="text-sm">Follow us on social media for the latest updates and exclusive offers!</p>
        </div>

        {/* Column 2 */}
        <div>
          <p className="font-bold mb-4 text-lg">Our Services</p>
          <ul className="space-y-2 text-sm">
            <li>Ads Campaign, Coupon, Promotion</li>
            <li>Digital Marketing</li>
             <li>FBA Operations Support</li>
            <li>Product Listing</li>
            <li>Brand Registry</li>
            <li>Brand Approval</li>
            <li>Category Approval</li>
            <li>GTIN Exemption</li>
            <li>Account Health</li>
            <li>Order Processing</li>
            <li>Keyword Optimization</li>
            <li>Safety Claim</li>
            <li>Payment Reconciliation</li>
            <li>Basic Training</li>
            <li>Sale Boost</li>
          </ul>
        </div>

        {/* Column 3 */}
        <div>
          <p className="font-bold mb-4 text-lg">Quick Links</p>
          <ul className="space-y-2 text-sm">
            <li>Partner</li>
            <li>Our Services</li>
            {/* <li>Calculator</li> */}
            <li>Free Onboarding</li>
            <li>Blog</li>
            <li>Contact Us</li>
            <li>Career</li>
            <li>Events</li>
            <li>About Us</li>
          </ul>
        </div>

        {/* Column 4 */}
        <div>
          <p className="font-bold mb-4 text-lg">Contact Us</p>
          <p className="text-sm font-semibold">Address</p>
          <p className="text-sm leading-relaxed">
            E-42/B, Ground Floor, Near Hira Sweets, Jawahar Park, Laxmi Nagar, Delhi, India 110092
          </p>

          <p className="mt-4 text-sm font-semibold">E-Mail</p>
          <p className="text-sm">info@esellersupport.in</p>

          <p className="mt-4 text-sm font-semibold">Helpline Number</p>
          <p className="text-sm">+91 8527203697, +91 9990614526</p>

          <div className="flex justify-center space-x-4 mt-6 text-2xl">
            <a href="https://www.facebook.com/people/E-Seller-Support/100094803307015/" target="_blank" rel="noopener noreferrer" className="fa fa-facebook"></a>
            <a href="https://www.instagram.com/esellersupport/" target="_blank" rel="noopener noreferrer" className="fa fa-instagram" ></a>
            <a href="https://x.com/" target="_blank" rel="noopener noreferrer" className="fa fa-twitter" ></a>
            <a href="https://www.linkedin.com/in/e-seller-support-37274b273/" target="_blank" rel="noopener noreferrer" className="fa fa-linkedin" ></a>
            <a href="https://www.youtube.com/@ESellerSupport" target="_blank" rel="noopener noreferrer" className="fa fa-youtube" ></a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Contentdown;
